import OrderTopbarKPITotals from './OrderTopbarKPITotals'
export default OrderTopbarKPITotals
